/**
 * Created by hp on 2017/6/29.
 */
const defaults = {
    productId: 0,
    giftNum: 1,
    money: 0,
    showGiftDialog: false,
    value: 1,
    closeText: '打包1份赠礼',
    giftValueFirst: [1, 2, 5],
    giftValueSecond: [10, 20, 50],
    giftValueSelected: 1,
    payType: '',
    payProduct: '',
    paySuccessUrl: '',
    payProductKey: '',
    lecturePrice: 0,
};

export default (state = defaults, action) => {
    switch (action.type) {
        case 'GIFT_SHOW_DIALOG':
            return {...state, showGiftDialog: true};
        case 'GIFT_HIDE_DIALOG':
            return {...state, showGiftDialog: false};
        case 'GIFT_RESET':
            return {...state, ...action.payload};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/gift.js